import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {GridViewModel} from "../../shared/models/ui/grid-view.model";
import {ButtonResponse} from "../util/ButtonResponse";

@Component({
    selector: 'bergh-grid-view',
    templateUrl: './grid-view.component.html',
    styleUrls: ['./grid-view.component.scss'],
    standalone: false
})
export class GridViewComponent {

  @Input() datas: GridViewModel[];
  @Input() isHoverImage: boolean = false;
  @Output() primaryButtonResponse: EventEmitter<ButtonResponse> = new EventEmitter();
  @Output() secondaryButtonResponse: EventEmitter<ButtonResponse> = new EventEmitter();
  @Output() pageNoToGo: EventEmitter<number> = new EventEmitter();
  p: number = 1;
  constructor() { }

  setStyle(listItem) {
    if (typeof listItem.style === 'function'){
      return listItem.style(listItem.data);
    }
    return '';
  }
}
